var match = () => {
    const env = process.env
    const { NODE_ENV } = env
    const {protocol, origin,hostname} = window.location
    let DEFAULTURL = {}
    let params = {}
    if (NODE_ENV === 'production') {
      params = {
        ip: origin,
        http: origin,
        base_api: origin,
        TOKENSEVER: origin,
        OSSIMG: 'https://biking-pod.oss-accelerate.aliyuncs.com/biking/coinlogo/'
      }
    } else if(NODE_ENV === 'cestest'){
        params = {
            ip: hostname,
            http: origin,
            base_api: origin,
            TOKENSEVER: origin,
            OSSIMG: 'https://biking-pod.oss-accelerate.aliyuncs.com/biking/coinlogo/'
          }
    }
    else {
        params = {
          ip: hostname,
          http: `${protocol}//${hostname}`,
          base_api: origin,
          TOKENSEVER: origin,
          OSSIMG: 'https://biking-pod.oss-accelerate.aliyuncs.com/biking/coinlogo/'
        }
    }
    const {ip, http, base_api, OSSIMG} = params
    const SERVETYPE = {
        BK: {
            IP: ip,
            HTTP:http,
            // IP:'https://www.bikingex0.com',
            // HTTP: `https://www.bikingex0.com`
        }
    }
    let SELECTTYPE = (types = 'BK', ads = 'IP') => SERVETYPE[types][ads];
    if (base_api.indexOf(SELECTTYPE)) {
        let NOTHTTP = base_api.replace('http://', '')
        if(NOTHTTP.indexOf('https://')>-1){
            NOTHTTP = base_api.replace('https://', '')
        }
        DEFAULTURL = {
            HTTP: SERVETYPE['BK'].HTTP,
            IP: SERVETYPE['BK'].IP,
            CONTRACTURL: '',
            WEBSOCKETURL: '',
            REQUSTURL: base_api,
            NOTHTTP,
            OSSIMG,
            TOKENSEVER: origin,
        }
    }
    return { ...process.env, ...DEFAULTURL };
}
const SERVEURL = match()
export { SERVEURL }


// WEBPACK FOOTER //
// ./src/assets/js/assetSeverUrl.js